import React from 'react';
import { Gift, CheckCircle } from 'lucide-react';
export function BonusSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/bBbitNVpyoL11rCKEWCwH8/BONO_1_POLITICA_Y_CIUDADANIA.png',
    number: 1,
    title: 'Mapa Anual de Política y Ciudadanía',
    description: 'Ves el año completo de un vistazo. Todas las unidades, temas y tiempos organizados en un solo mapa visual.',
    highlights: ['Planificación anual completa', 'Distribución por trimestre', 'Temas y subtemas ordenados']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/anH34fRy1sotJyGytEGhjL/BONO_2_PYC.png',
    number: 2,
    title: 'Evaluaciones Prácticas + Consignas Listas',
    description: 'Evaluás sin improvisar ni copiar de internet. Todo listo para imprimir y usar.',
    highlights: ['Evaluaciones escritas', 'Trabajos prácticos', 'Análisis de casos']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/2MBuwwrwYtEroDGsj9b5qu/BONO_3_PYC.png',
    number: 3,
    title: 'Casos Reales para Explicar Política',
    description: 'Los alumnos entienden porque lo viven. Situaciones reales de Argentina para debatir en clase.',
    highlights: ['Elecciones y protestas', 'Derechos vulnerados', 'Participación ciudadana']
  }];
  return <section className="bg-[#1e3a5a] py-12 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12" data-id="element-21">
          <div className="inline-flex items-center gap-2 bg-[#d4a853] text-[#1e3a5a] font-black text-sm sm:text-base px-5 py-2 rounded-full mb-4 shadow-lg" data-id="element-22">
            <Gift className="w-4 h-4" data-id="element-23" />
            BONOS GRATIS HOY
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white" data-id="element-24">
            Te llevás <span className="text-[#d4a853]" data-id="element-25">3 bonos exclusivos</span>
          </h2>
        </div>

        {/* Bonus Cards - Horizontal Layout */}
        <div className="space-y-4 sm:space-y-6" data-id="element-26">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-xl cursor-pointer transform transition duration-300 hover:shadow-2xl hover:scale-[1.01]" onClick={scrollToPurchase} data-id="element-27">
              <div className="flex flex-col sm:flex-row" data-id="element-28">
                {/* Image Side */}
                <div className="sm:w-2/5 lg:w-1/3 p-4 sm:p-6 flex items-center justify-center bg-gray-50" data-id="element-29">
                  <div className="relative" data-id="element-30">
                    {/* Badge */}
                    <div className="absolute -top-2 -left-2 z-10 flex gap-1.5" data-id="element-31">
                      <span className="bg-[#1e3a5a] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-32">
                        BONO {bonus.number}
                      </span>
                      <span className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-33">
                        GRATIS
                      </span>
                    </div>
                    <img src={bonus.image} alt={bonus.title} className="w-full max-w-[220px] sm:max-w-none rounded-lg" data-id="element-34" />
                  </div>
                </div>

                {/* Content Side */}
                <div className="sm:w-3/5 lg:w-2/3 p-4 sm:p-6 flex flex-col justify-center" data-id="element-35">
                  <h3 className="text-lg sm:text-xl font-bold text-[#1e3a5a] mb-2" data-id="element-36">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base mb-3" data-id="element-37">
                    {bonus.description}
                  </p>
                  <ul className="space-y-1.5" data-id="element-38">
                    {bonus.highlights.map((item, i) => <li key={i} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-39">
                        <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-40" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA */}
        <p className="text-center text-[#d4a853] mt-6 sm:mt-8 text-sm sm:text-base font-medium" data-id="element-41">
          👆 Tocá cualquier bono para acceder a la oferta completa
        </p>
      </div>
    </section>;
}